import { render, staticRenderFns } from "./GigLoader.htm?vue&type=template&id=0b407d3e&scoped=true&"
import script from "./GigLoader.ts?vue&type=script&lang=js&"
export * from "./GigLoader.ts?vue&type=script&lang=js&"
import style0 from "./GigLoader.scss?vue&type=style&index=0&id=0b407d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b407d3e",
  null
  
)

export default component.exports